<div class="ap-toolbar-control">
  <div [aptooltip]="(time | getLocalDate).format(FormatDate) + ' ' + FarmSettings.FarmTime" [perpetual]="true">
    {{(time | getLocalDate).format(FormatTime)}}
  </div>
</div>
